import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalService } from '@core/modals/services/modal.service';
import { SocketService } from '@core/services/socket.service';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-iframe-modal',
  templateUrl: './iframe-modal.component.html',
  imports: [SvgIconComponent],
  styleUrl: './iframe-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex items-center justify-center w-full',
  },
})
export class IFrameModal {
  // we have two variants how to get frameURL: from the body or from the endpoint
  body = input<string>('');
  endpoint = input<string>('');

  loadingState = signal(0);
  isLoaded = signal(false);

  frameURL = signal<SafeResourceUrl | null>(null);

  constructor(
    private sanitize: DomSanitizer,
    private socketService: SocketService,
    public modalService: ModalService
  ) {
    effect(() => {
      if (this.body()) {
        this.frameURL.set(
          this.sanitize.bypassSecurityTrustResourceUrl(this.body())
        );
      }
    });

    effect(async () => {
      if (this.endpoint()) {
        const body = await this.socketService.emit(this.endpoint());
        if (body) {
          this.frameURL.set(this.sanitize.bypassSecurityTrustResourceUrl(body));
        }
      }
    });
  }

  onLoad() {
    this.loadingState.update((value) => value + 1);
    if (this.loadingState() === 2) {
      this.isLoaded.set(true);
    }
  }
}
